//React
import React, { useEffect, useState } from 'react';
//API
import { DeviceApi } from '../../apis/index';
//Material-UI
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
//Components
import InfinityScroll from '../../components/InfinityScroll.js';
import MyCircularProgress from '../../components/Circleprogess.js';
//lodash
import { throttle } from 'lodash';

const Device = (props) => {
  const [devices, setDevices] = useState([]);

  const [search, setSearch] = useState(false);
  const [searchEnd, setSearchEnd] = useState(true);
  const [loading, setLoading] = useState(false);

  const [count, setCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    firstLoad();
  }, []);

  useEffect(() => {
    if (searchEnd) {
      if (count >= 1 && !search) {
        loadData();
      }
      if (count >= 1 && search) {
        loadsearchData();
      }
    }
  }, [count]);

  const loadDataCommon = async (isSearch, value, pageCount = 0) => {
    setLoading(false);

    const res = isSearch
      ? await DeviceApi.getSerachDeviceList(value, pageCount)
      : await DeviceApi.getDeviceList(pageCount);

    const transformedData = res.data.content.map((device) => ({
      data1: { key: 'ID', value: device.id },
      data2: { key: 'Serial Number', value: device.serialNumber },
      data3: { key: 'APP Version', value: device.appVersion },
      data4: { key: 'Approve', value: device.approveYn.toString() },
    }));

    setDevices((prev) =>
      pageCount === 0 ? transformedData : [...prev, ...transformedData],
    );

    if (res.data.numberOfElements !== 15) {
      setLoading(true);
      setSearchEnd(false);
    } else {
      setLoading(true);
    }
  };

  const firstLoad = async () => {
    await loadDataCommon(false);
  };

  const loadData = async () => {
    await loadDataCommon(false, null, count);
  };

  const loadFirstsearchData = async (value) => {
    setCount(0);
    setDevices([]);
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, 0);
  };

  const loadsearchData = async (value) => {
    setSearch(true);
    const searchValueToUse = value || searchValue;
    await loadDataCommon(true, searchValueToUse, count);
  };

  const handleChangeValue = (e) => {
    if (e.key === 'Enter' && e.target.value.toString().length !== 0) {
      const value = e.target.value.toString().trim();
      setCount(0);
      setSearchEnd(true);
      setDevices([]);
      setSearch(true);
      setSearchValue(value);
      loadFirstsearchData(value);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (e.key === 'Enter' && e.target.value.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const handleChangeValueClick = () => {
    if (searchValue.toString().length !== 0) {
      setCount(0);
      setSearchEnd(true);
      setDevices([]);
      setSearch(true);
      setSearchValue(searchValue);
      loadFirstsearchData(searchValue);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
    if (searchValue.toString().length === 0) {
      setCount(0);
      setSearchEnd(true);
      setSearch(false);
      firstLoad();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const hadlesearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleRowSelection = (e) => {
    props.history.push('/updateDevice/' + e);
  };

  const loadMoreItems = async () => {
    setCount((prevCount) => prevCount + 1);
    if (!searchEnd) {
      setLoading(false);
    }
  };

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    // 문서의 전체 높이
    const scrollHeight = document.documentElement.scrollHeight;
    // 끝
    const isAtBottom = scrollTop + windowHeight >= scrollHeight - 34;

    if (isAtBottom) {
      loadMoreItems();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', throttle(handleScroll, 1000));
    return () =>
      window.removeEventListener('scroll', throttle(handleScroll, 1000));
  }, []);

  //scroll Top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <InfinityScroll
        title="Device LIST"
        saveIcon={null}
        saveLink={null}
        saveName={null}
        searchPlaceholder="Enter device..."
        handleChangeValue={handleChangeValue}
        hadlesearchValue={hadlesearchValue}
        handleChangeValueClick={handleChangeValueClick}
        row={devices}
        column={[
          { key: 'ID', value: 'ID', width: '200' },
          { key: 'Serial Number', value: 'Serial Number', width: '200' },
          { key: 'APP Version', value: 'APP Version', width: '200' },
          { key: 'Approve', value: 'Approve', width: '200' },
        ]}
        handleRowSelection={handleRowSelection}
        searchFlag={false}
      />
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          marginTop: '20px',
        }}
      >
        {!loading ? <MyCircularProgress /> : <></>}
      </div>
      <ExpandCircleDownIcon
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '100px',
          right: '40px',
          cursor: 'pointer',
          fontSize: '50',
          rotate: '180deg',
          color: '#3F598C',
        }}
      ></ExpandCircleDownIcon>
    </>
  );
};

export default Device;
